(function () {
  'use strict';

  angular
    .module('app.referral-analytics')
    .service('referralAnalyticsService', referralAnalyticsService);

  /* @ngInject */
  function referralAnalyticsService($http, helperService) {
    /* jshint validthis: true */
    var vm = this;

    vm.quickview = quickview;
    vm.subjectGradeComparisons = subjectGradeComparisons;
    vm.teacherComparisons = teacherComparisons;
    vm.teacherDetails = teacherDetails;

    ////////////

    function quickview(filters) {
      // prepare filters

      return $http.get('/api/analytics/referral/quickview', {params: filters})
        .then(helperService.handleResponse)
        .then(function (data) {
          // Prepare data before view

          return data;
        });
    }

    function subjectGradeComparisons(filters) {
      // prepare filters

      return $http.get('/api/analytics/referral/subject-grade-comparisons', {params: filters})
        .then(helperService.handleResponse)
        .then(function (data) {
          // Prepare data before view

          return data;
        });
    }

    function teacherComparisons(filters) {
      // prepare filters

      return $http.get('/api/analytics/referral/teacher-comparisons', {params: filters})
        .then(helperService.handleResponse)
        .then(function (data) {
          // Prepare data before view

          return data;
        });
    }

    function teacherDetails(filters) {
      // prepare filters

      return $http.get('/api/analytics/referral/teacher-details', {params: filters})
        .then(helperService.handleResponse)
        .then(function (data) {
          // Prepare data before view

          return data;
        });
    }
  }
})();